import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';
import { useMakeResponsiveStyles } from 'kineticUtils';
import { MutableRefObject } from 'react';

// eslint-disable-next-line @typescript-eslint/no-var-requires
const mapPinRed = require('@qfa/react-components/lib/components/images/mapPinRed.png');

const useLocationFormDetailStyles = makeStyles(({ spacing, palette }) => {
  return createStyles({
    gridContainer: {
      overflow: 'auto',
      height: '100%',
    },
    fullHeight: {
      height: '100%',
    },
    textField: {
      display: 'flex',
      marginTop: spacing(),
      marginRight: spacing(),
      flex: 1,
    },
    button: {
      '&:hover': {
        color: palette.common.reds.map.light,
      },
    },
    buttonActive: {
      color: palette.common.reds.map.main,
      '&:hover': {
        color: palette.common.reds.map.dark,
      },
    },
    mapPinActive: {
      '& > div > div > div > #view-MapView': {
        cursor: `url(${mapPinRed}) 14 32, auto !important`,
      },
    },
    devicesContent: {
      paddingTop: spacing(3),
    },
    addDeviceButton: {
      marginBottom: spacing(),
    },
    emptyWrapper: {
      height: '100%',
      display: 'flex',
      justifyContent: 'center',
    },
    emptyContent: {
      display: 'flex',
      flexDirection: 'column',
      alignSelf: 'center',
      '& > *': {
        margin: spacing(),
      },
    },
    summary: {
      display: 'flex',
      flexDirection: 'row',
      width: '100%',
      alignItems: 'center',
    },
    summaryName: {
      flex: 1,
    },
    deviceAction: {
      marginTop: spacing(3),
      display: 'flex',
      flexDirection: 'column',
    },
    details: {
      overflow: 'visible',
    },
    detailsWrapper: {
      marginTop: spacing(3),
    },
    detailSection: {
      paddingLeft: `0 !important`,
    },
  });
});

export default useLocationFormDetailStyles;

export const useResponsiveStyles = (containerRef: MutableRefObject<HTMLElement | null>) => {
  return useMakeResponsiveStyles(containerRef, {
    mainContainer: {
      base: {
        display: 'flex',
        flexDirection: 'row',
        height: '100%',
        width: '100%',
        overflowY: 'scroll',
      },
      sm: { display: 'block', flexDirection: 'column' },
      md: { flexDirection: 'column' },
    },
    viewsContainer: {
      base: {
        height: '100%',
        flex: '60%',
      },
      sm: {
        width: '100%',
        height: '50%',
      },
      md: {
        width: '100%',
        height: '50%',
      },
    },
    mapContainer: {
      base: {
        height: '100%',
        flex: '40%',
      },
      sm: {
        flex: 0,
        width: '100%',
        height: '50%',
      },
      md: {
        flex: 0,
        height: '50%',
        width: '100%',
      },
    },
  });
};
